import { RelationshipAttributeCoreBase } from "./relationship-attribute.core.base"


export class RelationshipAttributeCore extends RelationshipAttributeCoreBase {

}